export default "__VITE_ASSET__Chpm_d6n__"